import 'utils/polyfills';
import React, { StrictMode } from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router';
import { createBrowserHistory } from 'history';

import LanguageProvider from 'jsx/locale/LanguageProviderV2';
import AuthProvider from 'jsx/auth/AuthProviderV2';
import ScrollToTop from 'jsx/layout/ScrollToTopV2';

import './main.less';
import { App } from './App';
import { CookieProvider } from 'jsx/auth/CookieProvider';

const history = createBrowserHistory();

const authConfig = {
  authUrl: process.env.REACT_APP_STS_URL,
  clientId: 'portfolioweb',
  scope: 'openid profile portfolioapi creditinfo sharedapi offline_access',
  secret: 'MyAPIHugeSecretKey',
};

render(
  <StrictMode>
    <AuthProvider authConfig={authConfig} history={history} restrict>
      <Router history={history}>
        <LanguageProvider>
          <CookieProvider>
            <ScrollToTop />
            <App />
          </CookieProvider>
        </LanguageProvider>
      </Router>
    </AuthProvider>
  </StrictMode>,
  document.getElementById('root')
);
